import type { CreateDepartmentDtoSchema, DepartmentSchema, UpdateDepartmentDtoSchema } from "@nexttrack/api-schema";

import { rootApi } from "@/store/services/root-api";

export const departmentsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getDepartments: builder.query<DepartmentSchema[], void>({
            query: () => "departments",
            providesTags: ["Department"],
        }),
        createDepartment: builder.mutation<DepartmentSchema, CreateDepartmentDtoSchema>({
            query: (body) => ({ url: "departments", method: "POST", body }),
            invalidatesTags: ["Department"],
        }),
        updateDepartment: builder.mutation<DepartmentSchema, { id: string; data: UpdateDepartmentDtoSchema }>({
            query: ({ id, data }) => ({ url: `departments/${id}`, method: "PATCH", body: data }),
            invalidatesTags: ["Department"],
        }),
        deleteDepartment: builder.mutation<void, string>({
            query: (id) => ({ url: `departments/${id}`, method: "DELETE" }),
            invalidatesTags: ["Department"],
        }),
    }),
});

export const {
    useGetDepartmentsQuery,
    useCreateDepartmentMutation,
    useUpdateDepartmentMutation,
    useDeleteDepartmentMutation,
} = departmentsApi;
